import {QuoteSummary} from "./quote-summary";
import {OpportunitySummary} from "./opportunity-summary";

export class QuoteDataSummary {
    quote: QuoteSummary;
    opportunity: OpportunitySummary;

    constructor(quote: QuoteSummary, opportunity: OpportunitySummary) {
        this.quote = quote;
        this.opportunity = opportunity;
    }
}
